import { render } from "./project-reports.vue?vue&type=template&id=3ffaf430"
import script from "./project-reports.vue?vue&type=script&lang=js"
export * from "./project-reports.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__